export default "__VITE_ASSET__BQ9cby2X__"